/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';
import { UserDataService } from 'app/shared/services/user-data.service';

@Injectable()
export class UserPreloadGuard implements CanActivate {
  constructor(private store: Store<fromStore.SharedState>, private userDataService: UserDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isLoginAsURL = !!route?.queryParams?.lt;
    return this.checkStore(isLoginAsURL).pipe(
      switchMap(() => of(true)),
      catchError((err) => {
        return of(false);
      })
    );
  }

  private checkStore(isLoginAsURL: boolean): Observable<any> {
    return this.store.select(fromStore.getUser).pipe(
      tap((userData: any) => {
        if (!userData.email && !isLoginAsURL) {
          const authToken = this.userDataService.getToken();
          if (authToken) {
            this.store.dispatch(new fromStore.GetUserByToken(authToken));
          }
        }
      }),
      filter((loaded) => !!loaded),
      take(1)
    );
  }
}
